import React, { useState } from 'react';
import ContactPopup from './ContactUsPopup';

function ContactUs() {
  const [isPopupOpen, setPopupOpen] = useState(false);

  return (
    <div>
    <div className="contact-fixed-butn">
      <div className="butn-presv">
        <a href="#" onClick={() => setPopupOpen(true)} className="butn butn-sm bg-white skew">
          <span className="text-dark">Contact Us</span>
         
        </a>
      </div>
     
    </div>
     <ContactPopup isOpen={isPopupOpen} closePopup={() => setPopupOpen(false)} />
     </div>
  );
}

export default ContactUs;




